import Popover from "@/component/Popover";
import IC_CONTROL_MORE from "@/assets/simulInter/ic_control_more.svg?react";
import IC_CONTROL from "@/assets/simulInter/ic_control.svg?react";
import IC_SYNC from "@/assets/flow/ic_sync.svg?react";
import { useState } from "react";
import { RuningInLink } from "@/constants";
import { message } from "antd";
import { IS_PRIVATE } from "@/config";

interface IControlPopoverProps {
  onControl: () => void;
  onSync: () => void;
}
const ControlPopover = ({ onControl, onSync }: IControlPopoverProps) => {
  const [showSelect, setShowSelect] = useState(false);

  const handleSync = () => {
    onSync();
    setShowSelect(false);
  };

  const handleControl = () => {
    if (!IS_PRIVATE && !RuningInLink) {
      message.warning('请前往应用端，使用设备控制功能');
      return;
    }
    onControl();
    setShowSelect(false);
  };

  return (
    <Popover
      placement="bottomRight"
      visible={showSelect}
      setVisible={setShowSelect}
      className="mt-2"
      content={
        <div className="w-60 h-26 flex flex-col justify-center">
          <div className="flex pl-2 cursor-pointer h-10" onClick={handleSync}>
            <IC_SYNC className="w-4.5 h-4.5 mt-0.5" />
            <div className="flex flex-col ml-2">
              <span className="text-mx-secondary text-size-3.5">
                连接加入
              </span>
              <span className="text-#A1A7B2 text-size-3">
                加入正在录制的大屏，查看会议内容
              </span>
            </div>
          </div>
          <div className="h-1px w-full bg-#000/10 my-2"></div>
          <div className="flex pl-2 cursor-pointer h-10" onClick={handleControl}>
            <IC_CONTROL className="w-4.5 h-4.5 mt-0.5" />
            <div className="flex flex-col ml-2">
              <span className="text-mx-secondary text-size-3.5">
                设备控制
              </span>
              <span className="text-#A1A7B2 text-size-3">
                控制大屏等设备的会议录制
              </span>
            </div>
          </div>
        </div>
      }
    >
      <div className="h-9.5 w-9.5 rd-2.5 no_drag flex flex-items-center flex-justify-center border-1 border-solid border-#383B50/30 ml-4 cursor-pointer">
        <IC_CONTROL_MORE className="w-4 h-4" />
      </div>
    </Popover>
  );
};

export default ControlPopover;
